<template>
  <div class="wrapper">
    <transition name="slide-in">
      <p
        v-show="show"
        class="bxp_loading-text"
      >{{text}}</p>
    </transition>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        items: [
          'We\'re configuring your bountiXP experience...',
          'Configuring workspace...',
          'Installing DB...',
          'Deploying...',
          'Workspace ready...'
        ],
        currentItem: 0,
        show: true,
        rotator: null
      }
    },
    computed: {
      text() {
        return this.items[this.currentItem]
      }
    },
    methods: {
      nextItem() {
        this.currentItem++
        this.show = true;
        if (this.isLastItem()) {
          clearInterval(this.rotator);
        }
      },
      isLastItem() {
        if (this.currentItem + 1 === this.items.length) {
          return true
        }
        return false
      }
    },
    mounted() {
      //Item rotator
      this.rotator = setInterval(() => {
        this.show = false;
        setTimeout(() => {
          this.nextItem();
        }, 500)
      }, 3500)
    }
  }
</script>

<style scoped>
  .wrapper {
    display: block;
    width: 100%;
    height: 20px;
    text-align: center;
  }

  .slide-in-enter {
    opacity: 0;
    transform: translateX(-60px) !important;
  }
  .slide-in-leave-to {
    opacity: 0;
    transform: translateX(60px) !important;
  }
  .slide-in-enter-to,
  .slide-in-leave {
    opacity: 1;
    transform: translateX(0) !important;
  }
  .slide-in-enter-active,
  .slide-in-leave-active {
    transition: all 250ms cubic-bezier(0.645, 0.045, 0.355, 1);
  }
</style>
